// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1966":"423548193db16a68","3899":"10522412c7bd8942"}[chunkId] + ".js";
};